import script from "./ClientSpecialFeaturesPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientSpecialFeaturesPopover.vue?vue&type=script&setup=true&lang=js"

import "./ClientSpecialFeaturesPopover.vue?vue&type=style&index=0&id=d2599152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2599152"]])

export default __exports__